export function debounce<F extends (...args: any[]) => Promise<void> | void>(
	func: F,
	delay = 0,
): F {
	let timeout = 0

	function debouncedFunction(this: any, ...args: any[]) {
		globalThis.clearTimeout(timeout)

		timeout = globalThis.setTimeout(() => {
			const result = func.apply(this, args)
			if (result instanceof Promise) {
				result.catch(console.error)
			}
		}, delay) as unknown as number
	}

	return debouncedFunction as F
}

export function debounceSubsequent<F extends (...args: any[]) => void>(func: F, delay = 0): F {
	let timeout: number | undefined = undefined

	function debouncedFunction(this: any, ...args: any[]) {
		if (!timeout) {
			func.apply(this, args)
		} else {
			globalThis.clearTimeout(timeout)
		}

		timeout = globalThis.setTimeout(() => {
			timeout = undefined
		}, delay) as unknown as number
	}

	return debouncedFunction as F
}

export function debounced(delay = 0, immediate = false) {
	return function (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
		const method = descriptor.value
		const timeout = Symbol()

		descriptor.value = function (this: any, ...args: any[]) {
			const invokeNow = immediate && !this[timeout]

			if (invokeNow) {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-call
				method.apply(this, args)
			}

			globalThis.clearTimeout(this[timeout])

			this[timeout] = globalThis.setTimeout(() => {
				if (!invokeNow) {
					// eslint-disable-next-line @typescript-eslint/no-unsafe-call
					method.apply(this, args)
				}
				this[timeout] = null
			}, delay) as unknown as number
		}

		return descriptor
	}
}
